import React, { useState, useEffect, useRef } from 'react';

import { isElementOverFlowing } from '../../utils';
import Tooltip from '../Tooltip/Tooltip';

const LabelWithTooltip = ({ name, tooltip, forceTooltip = false }) => {
  const nameReference = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (nameReference.current) {
      setIsOverflowing(isElementOverFlowing(nameReference.current));
    }
  }, [name]);

  return (
    <Tooltip
      content={tooltip || name}
      disabled={!forceTooltip && !isOverflowing}
    >
      <div
        className="ellipsed-text"
        ref={nameReference}
      >
        {name}
      </div>
    </Tooltip>
  );
};

export default LabelWithTooltip;
